// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"cc261081","105":"702995c4","443":"ead662e9","625":"7d618621"}[chunkId] + ".chunk.js";
};